import React from "react";

import ContentCard from "../../../../UI/ContentCard/ContentCard";
import ideaImg from "../../../../assests/images/idea.png";

const Idea = () => (
  <ContentCard
    title="THE IDEA"
    id="idea"
    image={ideaImg}
    imageTtitle="Our Idea"
    frontText="In early 2018 the founders team wondered what it would take to produce perfect customized clothes while not knowing a thing about the industry."
    backTextOne="In early 2018 the founders team wondered what it would take to produce perfect customized clothes while not knowing a thing about the industry.
        We liked the idea of offering a platform, where people can make their own design decisions."
    backTextTwo="  For two reasons it was clear, that we wanted to try this and that we are not only talking about placing the customer‘s print design
        on a cheap garment made under questionable circumstances."
    backTextThree="The first reason: You can find this all over the market and for us this is just a contradiction in itself. The customer spends hours, sometimes days,
        to design true art work. So from our point of view this special art work needs to be placed on a special high quality garment to become the perfect piece.
        Therefore we intended for the customer to have true decision options in terms of everything, that belongs to a garment. Next to the print design
        that would be fabrics, pattern, style, color and accessories."
    backTextFour="The second reason: The production chain of the „fast fashion“ industry is unreasonable. Until today the industry first produces millions
        of garments every week and than spends millions of marketing dollars to convince the people what to buy and wear. Not everything is meeting the need
        or taste of the customer. So millions of garments are burned every year to clear the space for the next stuff. We start our way on the other end.
        We first ask the customer, then produce the perfect piece in terms of taste, quality and fit. For you that means a longlasting special piece in
        your wardrobe. For us it means happy convinced customers, low return rates and investing in quality instead of commercials."
    backTextFive="  Our goal is that together with the SAMPELL community we create favourite pieces that you want to wear forever. We want that at some point in the
        near future people have, in their wardrobes, only garments that are of high quality, fit perfectly and are of their own great style."
  />
);

export default Idea;



// WEBPACK FOOTER //
// ./src/components/Pages/Progress/Content/Idea.js